<template>
    <c-modal
        @show="showModal"
        v-model="modal"
        size="xl"
        centered
        :tag="false"
        :title="'Add Menu Type'"
        confirm-label="Save"
        cancel-label="Cancel"
        :progressing="progressing"
        @submit="submit"
        @hide="clearForm"
    >
        <template>
            <b-container fluid class="px-0">
                <b-row>
                    <b-col cols="12" md="6">
                        <b-form-group>
                            <b-input-group prepend="Menu Type Name">
                                <b-input
                                    class="myFeild"
                                    name="Menu Type Name"
                                    placeholder="Required"
                                    v-model="model.MenuType"
                                    v-validate="'required'"
                                />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" class="text-center mb-3 mb-md-0">
                        <b-form-checkbox v-model="model.IsVisible">
                            Hide this menu for users
                        </b-form-checkbox>
                    </b-col>
                    <b-col cols="12">
                        <b-form-group>
                            <b-input-group prepend="Comments">
                                <b-textarea
                                        name="Comments"
                                        class="myFeild"
                                        placeholder="Optional"
                                        v-model="model.MenuTypeComment"
                                />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-4 mt-3 warning-form-control">
                    <b-col cols="12" md="4">
                        <b-form-checkbox v-model="model.CanBePickup"  switch size="lg">
                            Accept Pickup Orders
                        </b-form-checkbox>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-checkbox :disabled="model.IsSpecial" v-model="model.CanBeDelivered" size="lg" switch>
                            Accept Delivery Orders
                        </b-form-checkbox>
                    </b-col>

                    <b-col cols="12" md="4">
                        <b-form-checkbox v-model="model.CanBeDinein"  switch size="lg">
                            Accept Dine in Orders
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mb-2">
                        <div class="bg-light p-2">
                            <div class="d-flex justify-content-between">
                                <b-form-checkbox style="flex-basis: 130px" v-model="model.IsSpecial" @input="changeSpecial">
                                    Special Event
                                </b-form-checkbox>
                                <span v-if="model.IsSpecial" class="font-weight-bold text-danger">
                                Delivery is not available for special event menus
                            </span>
                                <span></span>
                            </div>
                            <b-row class="mt-3" v-if="model.IsSpecial">
                                <b-col cols="12" md="6" class="mb-3 mb-md-0">
                                    <b-input-group prepend="Event Start Date">
                                        <b-form-datepicker
                                                locale="en-US"
                                                name="Event Start Date"
                                                :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                                                :min="maxDate"
                                                @input="changeStartDate"
                                                v-validate="dateValidation"
                                                id="from-example-datepicker" v-model="model.StartDate"></b-form-datepicker>
                                    </b-input-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-input-group prepend="Event End Date">
                                        <b-form-datepicker
                                                locale="en-US"
                                                name="Event End Date"
                                                :date-format-options="{'year': 'numeric', 'month': 'long', 'day': 'numeric'}"
                                                :min="maxDateByToDate"
                                                v-validate="dateValidation"
                                                id="to-example-datepicker" v-model="model.EndDate"></b-form-datepicker>
                                    </b-input-group>
                                </b-col>
                                <b-col cols="12" class="mt-3">
                                    <b-form-checkbox v-model="model.HideAfterEndDate">
                                        Do Not show this menu to users after event end date
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="font-weight-bold mb-3">
                            Menu Availability
                        </div>
                        <div>
                            <b-form-group v-slot="{ ariaDescribedby }">
                                <b-form-radio
                                    class="mb-2"
                                    v-model="model.IsTimeBased"
                                    :aria-describedby="ariaDescribedby"
                                    name="some-radios"
                                    :value="false"
                                >Same as current weekly hours of operation of restaurant</b-form-radio>
                                <b-form-radio
                                    v-model="model.IsTimeBased"
                                    :aria-describedby="ariaDescribedby"
                                    name="some-radios"
                                    :value="true"
                                >
                                    Time Limited
                                </b-form-radio>
                            </b-form-group>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <b-col v-if="model.IsTimeBased" cols="12" md="9">
                        <b-container class="px-0">
                            <b-row v-for="day in MenuTypeHours" class="mb-2">
                                <b-col cols="4" class="flex-grow-1">
                                    {{day.day}}
                                </b-col>
                                <b-col cols="3" class="flex-grow-1">
                                    <b-form-checkbox v-model="day.unAvailable">
                                        unavailable
                                    </b-form-checkbox>
                                </b-col>
                                <b-col v-if="!day.unAvailable" cols="5" class="d-flex flex-grow-1">
                                    <b-select v-model="day.fromValue" :options="hours"/>
                                    <b-select class="ml-2" v-model="day.toValue" :options="hours"/>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                            <ul class="m-0 px-1">
                                <li v-for="err in errors.all()" :key="err">{{err}}</li>
                            </ul>
                        </b-alert>
                    </b-col>
                </b-row>
            </b-container>
        </template>

    </c-modal>
</template>

<script>
    import CModal from "../../../shared/Cmodal";
    export default {
        name: "createMenuType",
        components: {CModal},
        props: {
            value: {required: true, type: Boolean},
            menuId: {
                type: [String, Number]
            }
        },
        computed: {
            modal: {
                get () {
                    return this.value
                },
                set (val) {
                    this.$emit('input', val)
                }
            },
            maxDate () {
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            maxDateByToDate () {
                const splitDate = this.model.StartDate ? this.model.StartDate.split('-') : []
                const now = splitDate.length ? new Date(splitDate[0], this.validMonth(splitDate[1]), splitDate[2]) : new Date()
                console.log(splitDate[1])
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                const maxDate = new Date(today)
                return maxDate
            },
            dateValidation () {
                return this.model.IsSpecial ? {required: true} : {required: false}
            }
        },
        data () {
            return {
                progressing: false,
                model: {
                    MenuType: null,
                    MenuTypeComment: null,
                    IsSpecial: false,
                    CanBeDelivered: false,
                    CanBePickup: false,
                    CanBeDinein: false,
                    HideAfterEndDate: true,
                    IsVisible: false,
                    IsTimeBased: false,
                    Menu: 0,
                    StartDate: '',
                    EndDate: '',
                    MenuTypeHours: []
                },
                MenuTypeHours: [
                    {day: 'Sun', WeekDayId: 0,  fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Mon', WeekDayId: 1, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Tue', WeekDayId: 2, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Wed', WeekDayId: 3, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Thu', WeekDayId: 4, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Fri', WeekDayId: 5, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                    {day: 'Sat', WeekDayId: 6, fromValue: "07:30 AM", toValue: "07:30 AM", unAvailable: false},
                ],
                hours: [
                    "07:00 AM",
                    "07:30 AM",
                    "08:00 AM",
                    "08:30 AM",
                    "09:00 AM",
                    "09:30 AM",
                    "10:00 AM",
                    "10:30 AM",
                    "11:00 AM",
                    "11:30 AM",
                    "12:00 PM",
                    "12:30 PM",
                    "01:00 PM",
                    "01:30 PM",
                    "02:00 PM",
                    "02:30 PM",
                    "03:00 PM",
                    "03:30 PM",
                    "04:00 PM",
                    "04:30 PM",
                    "05:00 PM",
                    "05:30 PM",
                    "06:00 PM",
                    "06:30 PM",
                    "07:00 PM",
                    "07:30 PM",
                    "08:00 PM",
                    "08:30 PM",
                    "09:00 PM",
                    "09:30 PM",
                    "10:00 PM",
                    "10:30 PM",
                    "11:00 PM",
                    "11:30 PM",

                    "12:00 AM",

                    "12:30 AM",
                    "01:00 AM",
                    "01:30 AM",
                    "02:00 AM",
                    "02:30 AM",
                    "03:00 AM",
                    "03:30 AM",
                    "04:00 AM",
                    "04:30 AM",
                    "05:00 AM",
                    "05:30 AM",
                    "06:00 AM",
                    "06:30 AM",
                ],
                menuTypes: [
                    {text: 'Food', value: 0},
                    {text: 'Drink', value: 1},
                ]
            }
        },
        methods: {
            validMonth (month) {
                switch (month) {
                    case '01': return '00';
                        break;
                    case '02': return '01';
                        break;
                    case '04': return '03';
                        break;
                    case '05': return '04';
                        break;
                    case '06': return '05';
                    break;
                    case '07': return '06';
                    break
                    case '08': return '07';
                    break;
                    case '09': return '08';
                    break;
                    case '10': return '09';
                    break
                    case '11': return '10'
                    break
                    case '12': return '11';
                    break;
                    default: return ''
                }
            },
            showModal () {
                this.model.IsSpecial = false
                this.model.IsTimeBased = false
                this.model.Menu = this.menuId
            },
            changeSpecial (val) {
                if (val) {
                    this.model.CanBeDelivered = false
                }
            },
            changeStartDate () {
                this.model.EndDate = ''
            },
            clearForm () {
                const model = {
                    MenuType: null,
                    MenuTypeComment: null,
                    IsSpecial: false,
                    CanBeDelivered: false,
                    CanBePickup: false,
                    CanBeDinein: false,
                    HideAfterEndDate: true,
                    IsVisible: false,
                    IsTimeBased: false,
                    Menu: 0,
                    StartDate: '',
                    EndDate: '',
                    MenuTypeHours: []
                }
                this.$validator.reset(() => {
                    this.model = model
                })
            },
            submit () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        let model = {...this.model}
                        model.IsSpecial = model.IsSpecial ? 1 : 0
                        model.CanBeDelivered = this.$convertBoolean(model.CanBeDelivered)
                        model.CanBePickup = this.$convertBoolean(model.CanBePickup)
                        model.CanBeDinein = this.$convertBoolean(model.CanBeDinein)
                        model.HideAfterEndDate = this.$convertBoolean(model.HideAfterEndDate)
                        model.IsVisible = model.IsVisible ? 0 : 1
                        // model.IsVisible = !model.IsVisible
                        model.UserID = localStorage.getItem('userID')
                        model.RestaurantID = this.$store.state.selectedRestaurantId
                        model.MenuTypeHours = model.IsTimeBased ? this.MenuTypeHours.map(item => {
                            return {
                                WeekDayId: item.WeekDayId,
                                StartTime: item.unAvailable ? 'Unavailable' : item.fromValue,
                                EndTime: item.unAvailable ? 'Unavailable' : item.toValue,
                            }
                        }) : []
                        model.IsTimeBased = this.$convertBoolean(model.IsTimeBased)
                        model.MenuTypeHours = JSON.stringify(model.MenuTypeHours)
                        this.progressing = true
                        
                        return this.$api.menuType.create(model).then(res => {
                            this.progressing = false
                            this.modal = false
                            this.model = {
                                MenuType: null,
                                MenuTypeComment: null,
                                IsSpecial: false,
                                CanBeDelivered: false,
                                CanBePickup: false,
                                CanBeDinein: false,
                                HideAfterEndDate: true,
                                IsVisible: false,
                                IsTimeBased: false,
                                Menu: 0,
                                StartDate: '',
                                EndDate: '',
                                MenuTypeHours: []
                            }
                            this.$emit('refresh')
                            // if (res.success) {
                            //
                            // } else {
                            //     this.$showError(res.message)
                            // }
                        }).catch(err => {
                            console.log(err)
                            this.progressing = false
                        })
                    }
                })
                
            },
            deleteMenuType () {

            }
        }
    }
</script>

<style lang="scss">
    .warning-form-control {
        .custom-control-input:checked ~ .custom-control-label::before{
            background-color: #FFB300 !important;
            border-color: #FFB300 !important;
        }
    }

</style>
